const State = {
  meta: {},
  summary: {},
  orderList: [],
  orderIncompleteList: [],
  orderPaymentList: [],
  orderDetailList: [],
  bulkOperationCompleted: false
}

export default State
